module.exports = __webpack_public_path__ + "static/media/thumbnail.2f5f901a.jpg";